<template>
 <div class="analtics" :class="{ 'map-visible-top': isMapVisible }">
  <DescriptionModal class="description-modal"
    :style="{ top: show === false ? '-50px' : '-90px'}"
    :description="`This section helps determine how many people answered different types of questions during the kit activation process (Map Analysis 2).`" />
    <city-state-filter v-if="show===false"></city-state-filter>
    <div class="container" :class="{ 'map-visible': isMapVisible }">
    <AnalyticsCount
      @shows="setShow"
      v-if="show===false"
      :is-research2="true"
      :survey-counts="surveyCounts"
      :active-filters="activeFilters"
      :selected-risk-filter="selectedRiskFilter"
      :filtered-kits="filteredKits"
      @select-survey-filter="handleSelectSurveyFilter"
    ></AnalyticsCount>
    <AnalyticsList v-if="show===true && !isMapVisible"
        @showModal="showModal"
        @showComment="showComment"
        :is-research2="true"
        :filtered-kits="filteredKits"
        :selected-risk-filter="selectedRiskFilter"
        :active-filters="activeFilters"
        @back-to-map="setShow({ show: false })"
    ></AnalyticsList>
    <template v-if="show===false">
       <Map2
         ref="map2"
         @update-survey-counts="handleUpdateSurveyCounts"
         @update-filters="handleUpdateFilters"
         @update-map-state="handleUpdateMapState"
       ></Map2>
    </template>
     
    </div>
 </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import AnalyticsCount from "./analytics/AnalyticsCount.vue";
import AnalyticsList from "./analytics/AnalyticsList.vue";
import CityStateFilter from './research/CityStateFilter.vue';
import Map2 from "./research/Map2.vue";

export default {
  name: "Analytics2",
  data(){
    return {
        show: false,
        surveyCounts: null,
        selectedRiskFilter: null,
        filteredKits: [],
        activeFilters: {
          musty_damp_odor: "Any",
          visible_mold: "Any",
          symptoms: "Any"
        }
    };
  },
  components:{
      AnalyticsCount,
      AnalyticsList,
      Map2,
      CityStateFilter
  },
  watch:{
    getAnalyticsStatus(obj) {
      this.setAnaltics(obj.show);
      this.show = obj.show;
    }
  },
  computed:{
    ...mapGetters(["getAnalyticsStatus","isMapVisible"])
  },
  methods:{
    ...mapActions([
        "setAnaltics"
    ]),
    setShow(obj){
       this.setAnaltics(obj.show);
       this.show = obj.show;
    },
    showModal(boolean) {
      this.$emit("showModal", boolean);
    },
    showComment(obj) {
      this.$emit("showComment", obj);
    },
    handleUpdateSurveyCounts(counts) {
      this.surveyCounts = counts;
    },
    handleUpdateFilters(filters) {
      this.activeFilters = { ...filters };
    },
    handleUpdateMapState({ filteredKits, selectedRiskFilter, filters }) {
      this.filteredKits = filteredKits || [];
      this.selectedRiskFilter = selectedRiskFilter || null;
      if (filters) {
        this.activeFilters = { ...filters };
      }
    },
    handleSelectSurveyFilter({ type, response }) {
      if (this.$refs.map2) {
        this.$refs.map2.toggleSurveyFilter(type, response);
      }
    }
  },
}
</script>
<style scoped>
.description-modal{
  text-align: end;
  position: absolute;
  z-index: 1;
  width: 100%;
}
.analtics {
  background-color: #e6ecf0;
  max-width: 100%;
  width: 100vw;
  min-height: 95vh;
  position: relative;
}
.map-visible {
  margin-bottom: 20px;
  bottom: 10px;
}
.map-visible-top{
  top: 30px;
}
@media print {
  .analtics {
    min-height: 10vh;
  }
}
</style>
